import React, { useMemo } from 'react';
import { track } from '../../services/analytics';
import { getProductsByCategory } from '../../data/affiliateProducts';

const GearSection = () => {
  const products = useMemo(() => getProductsByCategory('general', 4), []);

  if (!products || products.length === 0) return null;

  const handleClick = (item, position) => {
    track('affiliate_click', {
      product: item.name,
      productId: item.id,
      category: item.category,
      program: item.program,
      position: `homepage_gear_${position}`,
    });
  };

  return (
    <section className="py-32 px-8 bg-surface">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-baseline gap-4 mb-20 pb-8">
          <h2 className="font-headline text-5xl italic text-primary">Curated Gear</h2>
          <span className="font-body text-on-surface-variant text-lg">Essential tools for the modern naturalist explorer.</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
          {products.map((product, i) => (
            <a
              key={product.id}
              href={product.url}
              target="_blank"
              rel="sponsored noopener noreferrer"
              onClick={() => handleClick(product, i)}
              className="group block"
            >
              <div className="aspect-[4/5] bg-surface-container-highest rounded-md mb-6 overflow-hidden relative">
                <img
                  alt={product.name}
                  className="w-full h-full object-cover opacity-90 transition-transform duration-500 group-hover:scale-105"
                  src={product.image}
                  loading="lazy"
                />
              </div>
              <span className="font-label text-[10px] uppercase tracking-widest text-secondary mb-2 block">
                {product.category}
              </span>
              <h4 className="font-headline text-xl mb-1 text-on-surface group-hover:text-primary transition-colors">
                {product.name}
              </h4>
              <p className="text-on-surface-variant text-sm font-body mb-4 line-clamp-2">
                {product.description}
              </p>
              <span className="font-body font-bold text-on-surface">{product.price}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GearSection;
